import * as React from 'react';
import './TournamentInviteBookingModal.scss';

interface Detail {
  label: string;
  value: React.ReactNode;
}

interface Props {
  title: string;
  description: string;
  details: Detail[];
  onClose: () => void;
  isWaitingList?: boolean;
  children?: React.ReactNode;
  actions?: React.ReactNode;
}

export const TournamentInviteBookingModalContent: React.FC<Props> = ({
  title,
  description,
  details,
  onClose,
  isWaitingList = false,
  children,
  actions
}) => (
  <div className="tournamentBookingModal">
    <header className="tournamentBookingModal__head">
      <span className={isWaitingList ? 'tournamentBookingModal__icon isWaiting' : 'tournamentBookingModal__icon'}>
        {isWaitingList ? (
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M7 3h10M7 21h10M8 3v4c0 2 4 3 4 5s-4 3-4 5v4M16 3v4c0 2-4 3-4 5s4 3 4 5v4" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M8 4h8v3a4 4 0 0 1-8 0V4ZM8 6H5v1a4 4 0 0 0 4 4M16 6h3v1a4 4 0 0 1-4 4M12 11v5M9 20h6M10 16h4" />
          </svg>
        )}
      </span>
      <div>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
      <button type="button" className="tournamentBookingModal__close" onClick={onClose} aria-label="Close">
        <span>&times;</span>
      </button>
    </header>

    <div className="tournamentBookingModal__body">
      <dl className="tournamentBookingModal__details">
        {details.map(detail => (
          <div key={detail.label}>
            <dt>{detail.label}</dt>
            <dd>{detail.value || '—'}</dd>
          </div>
        ))}
      </dl>

      {isWaitingList ? (
        <section className="tournamentBookingModal__notice">
          <span className="tournamentBookingModal__noticeIcon" aria-hidden="true">
            i
          </span>
          <div>
            <h3>Waiting list information</h3>
            <p>Your school will not be added to the participant list immediately.</p>
            <p>
              Once a space becomes available and the organisers move your school into the participant list, you will be
              notified and you will then be able to manage your participation from your upcoming tournaments.
            </p>
          </div>
        </section>
      ) : null}

      {children}
    </div>

    {actions ? <footer className="tournamentBookingModal__foot">{actions}</footer> : null}
  </div>
);

TournamentInviteBookingModalContent.displayName = 'TournamentInviteBookingModalContent';
